import StylizedMaterialReactTable from './StylizedMaterialReactTable';
import { withErrorBoundary } from '../../SystemComponent/ErrorBoundary';

export default withErrorBoundary('StylizedMaterialReactTable')(StylizedMaterialReactTable);
